<template>
  <div class="my-sidebar-nav-box">
    <ul>
      <li v-for="(item,index) in navList" :key="index">
        <dl class="single-menu-class-box">
          <dt class="show-flex-box-r menu-shrink-status">
            <h3>{{item.title}}</h3>
            <em></em>
          </dt>
          <dd>
            <div
              v-for="(cItem,cIndex) in item.children"
              :key="cIndex"
              :class="{'show-flex-box-r show-flex-center': true,'current-select-route': currentRouter == cItem.type}"
              @click="switchRoute(cItem)"
            >
              <span>
                <strong>{{cItem.title}}</strong>
                <em
                  v-if="cItem.type == 'messageCenter' && startupData && startupData.un_read_message_count && startupData.un_read_message_count > 0"
                ></em>
              </span>
            </div>
          </dd>
        </dl>
      </li>
    </ul>
  </div>
</template>

<script>
import regex from "@/filter/regex";

export default {
  name: "mySidebarNav",
  data() {
    return {
      navList: [
        {
          title: "个人中心",
          children: [
            {
              title: "消息中心",
              type: "messageCenter",
              dynamic: true,
              path: "/web/my/personal/message_center"
            },
            {
              title: "个人资料",
              type: "personalData",
              dynamic: false,
              path: "/web/my/personal/personal_data"
            },
            {
              title: "我的收藏",
              type: "myCollect",
              dynamic: false,
              path: "/web/my/personal/my_collect"
            },
            {
              title: "我的课程",
              type: "myCourse",
              dynamic: false,
              path: "/web/my/personal/my_course"
            },
            {
              title: "我的钱包",
              type: "myWallet",
              dynamic: false,
              path: "/web/my/personal/my_wallet"
            },
            {
              title: "考级报名",
              type: "distinction",
              dynamic: false,
              path: "/web/my/personal/distinction_information"
            }
          ]
        },
        {
          title: "商城",
          children: [
            {
              title: "订单",
              type: "myOrder",
              dynamic: false,
              path: "/web/my/store"
            },
            {
              title: "购物车",
              type: "shoppingCart",
              dynamic: false,
              path: "/web/my/store/shopping_cart"
            },
            {
              title: "我的发票",
              type: "myInvoice",
              dynamic: false,
              path: "/web/my/store/my_invoice"
            },
            {
              title: "我的评价",
              type: "myEvaluate",
              dynamic: false,
              path: "/web/my/store/my_evaluate"
            },
            {
              title: "地址管理",
              type: "myAddressAdministration",
              dynamic: false,
              path: "/web/my/store/address_administration"
            },
            {
              title: "退款/售后",
              type: "myRefundAftersale",
              dynamic: false,
              path: "/web/my/store/refund_aftersale"
            }
          ]
        },
        {
          title: "系统",
          children: [
            {
              title: "设置",
              type: "mySetting",
              dynamic: false,
              path: "/web/my/system/setting"
            },
            {
              title: "常见问题",
              type: "myCommonIssue",
              dynamic: false,
              path: "/web/my/system/common_issue"
            },
            {
              title: "意见反馈",
              type: "feedback",
              dynamic: false,
              path: "/web/my/system/feedback"
            },
            {
              title: "关于我们",
              type: "aboutUs",
              dynamic: false,
              path: "/web/my/system/about_us"
            }
          ]
        }
      ],
      currentRouter: "",
      startupData: false
    };
  },
  created() {
    this.startupData = this.listenStartupData;
  },
  computed: {
    listenStartupData: function() {
      return this.$store.state.startup;
    }
  },
  mounted() {
    this.bindNavBoxShowStatus();
    this.setCurrentRouteChoose();
  },
  methods: {
    setCurrentRouteChoose: function() {
      var routInfo = this.$route;
      this.currentRouter = routInfo.name;
    },
    switchRoute: function(routInfo) {
      var toWhere = routInfo.path;
      this.$router.push({ path: toWhere });
    },
    bindNavBoxShowStatus: function() {
      $(".single-menu-class-box>dt").on("click", function() {
        let hasShowClass = $(this).hasClass("menu-shrink-status");

        if (hasShowClass) {
          $(this).removeClass("menu-shrink-status");
          $(this)
            .parent()
            .children("dd")
            .slideUp();
        } else {
          $(this).addClass("menu-shrink-status");
          $(this)
            .parent()
            .children("dd")
            .slideDown();
        }
      });
    }
  },
  watch: {
    $route: function(to, from) {
      this.setCurrentRouteChoose();
    },
    listenStartupData: function() {
      this.startupData = this.listenStartupData;
    }
  }
};
</script>
<style lang="less" scoped>
.my-sidebar-nav-box {
  background: #f1f0ec;
  & > ul {
    & > li {
      & > dl {
        border-bottom: 1px solid #e9e7e1;
        & > dt {
          height: 63px;
          padding-left: 20px;
          padding-right: 15px;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          & > h3 {
            font-size: 16px;
            font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
            font-weight: 600;
            color: #302929;
          }
          & > em {
            display: block;
            width: 20px;
            height: 10px;
            transition: all 0.3s ease;
            transform: rotateZ(-180deg);
            background: url("../../../assets/my/my_sidebar_icon_1.png") center
              center no-repeat;
            background-size: 100% 100%;
          }
        }
        & > dt.menu-shrink-status {
          & > em {
            transform: rotateZ(0);
          }
        }
        & > dd {
          & > div {
            width: 100%;
            height: 47px;
            cursor: pointer;
            & > span {
              position: relative;
              display: block;
              & > strong {
                font-size: 14px;
                font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
                font-weight: 500;
                color: #302929;
              }
              & > em {
                position: absolute;
                width: 8px;
                height: 8px;
                top: 0;
                right: -10px;
                border-radius: 8px;
                background: #e60012;
              }
            }
          }
          & > div.current-select-route,
          & > div:hover {
            background: #302929;
            & > span {
              & > strong {
                color: #fff;
              }
              & > em {
              }
            }
          }
        }
      }
    }
    & > li:last-child {
      & > dl {
        border-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/my/nav/my_sidebar_nav.vue